var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-head"},[_c('headers')],1),_c('div',{staticClass:"page-body"},[_c('div',{staticClass:"Material"},[_c('material')],1),_c('div',{staticClass:"Renderer"},[_c('renderer')],1),_c('div',{staticClass:"Setting"},[_c('setting')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }